import { resolveImage } from "../data/assetMap";
import { DownloadIcon } from "./icons";
import { docFileUrl, downloadFile } from "../utils/download";

export default function PreviewModal({ doc, onClose }) {
  if (!doc) return null;
  const imgUrl = resolveImage(doc.prevUrl || doc.prev);
  return (
    <div className="overlay overlay--preview" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="preview-box">
        <div className="preview-box__head">
          <span className="preview-box__name">{doc.name}</span>
          {docFileUrl(doc) && (
            <button
              type="button"
              className="btn-preview btn-download preview-box__download"
              aria-label={"Download " + doc.name}
              onClick={() => downloadFile(docFileUrl(doc), doc.name)}
            >
              <DownloadIcon size={13} />
              Download
            </button>
          )}
          <button type="button" className="preview-box__close" onClick={onClose}>
            {"×"}
          </button>
        </div>
        <div className="preview-box__img" style={{ backgroundImage: imgUrl ? `url("${imgUrl}")` : "none" }} />
      </div>
    </div>
  );
}
